export const PLACES = {
    SAGAMIDAI_SHOU: '相模台小',
    SAKURADAI_SHOU: '桜台小'
} as const;

export const PLACE_VALUES = Object.values(PLACES);
export const PLACE_KEYS = Object.keys(PLACES);

export type Place = typeof PLACES[keyof typeof PLACES];

export const isPlace = (value: any): value is Place => PLACE_VALUES.includes(value);
